import type {PageRouteConfig} from '@router';

import {type HeaderDataPayload} from '@ds/types';
import {useRouteBuildContext} from '@router';
import ChortkeShow from 'modules/Chortke/Show/ChortkeShow';
import {useCallback} from 'react';

function ChortkeShowItemPageElement() {
  const {updateHeaderData} = useRouteBuildContext();
  const handleHeaderData = useCallback(
    ({action, icon, iconTitle}: HeaderDataPayload) => {
      updateHeaderData('showChortke', {action, icon, iconTitle});
    },
    [updateHeaderData]
  );

  return <ChortkeShow headerData={handleHeaderData} />;
}

export function createChortkeShowItemRoute(): PageRouteConfig {
  return {
    element: <ChortkeShowItemPageElement />,
    layout: {
      title: 'چرتکه',
      hasNavigate: false,
      hasBack: true,
      hasHeader: true,
      headerDataKey: 'showChortke',
      link: -1
    },
    initialHeaderData: {
      showChortke: {icon: '', iconTitle: '', action: null, title: ''}
    }
  };
}
